webpackJsonp([4],{

/***/ 100:
/***/ (function(module, exports) {

module.exports = {"social_icons":{"id":"social_icons","title":"Social Icons","type":"social_icons","tab":"Social","preview_file":"sm_inline_icons_trans-socialbar.svg","template":{},"fields":[],"styles":{"height":"auto"}},"gmap":{"id":"gmap","title":"Google Maps","tab":"Tools","ui_template":"html","general_help":"<div>INFO </br>Enter a location.</div>","preview_file":"sm_inline_menu_app-google-maps.svg","contains_iframe":true,"keep_aspect_ratio":true,"drag_placeholder":"sm_draggable_placeholder-googlemaps.svg","template":{"template":"<iframe src='https://www.google.com/maps/embed/v1/place?key=AIzaSyCgCurk0blZMoeYgNNcGbs0DmnxsKyQHzQ&q={{query}}&zoom={{zoom}}' width='100%' height='100%'  frameborder='0' style='border:0'></iframe>"},"fields":[{"type":"String","fallback":"London","label":"Location","id":"query","required":true},{"type":"Number","fallback":300,"label":"Width","id":"width","hidden":true,"required":true,"min":0,"max":1900},{"type":"Number","fallback":300,"label":"Height","id":"height","hidden":true,"required":true,"min":0,"max":1900},{"type":"Slider","label":"Zoom","id":"zoom","required":true,"min":0,"max":20,"fallback":8}],"classes":["embed-responsive","embed-responsive-16by9"]},"google_search":{"id":"google_search","title":"Google Search","tab":"Tools","ui_template":"html","general_help":"Enter your Google search engine ID. </br></br>You will need to create your own custom search engine with Google in order to get access to your ID.</br></br>(Please note: You need to verify your site with Google Webmaster tools before you will be able to use Google Custom Search Engine).","preview_file":"sm_inline_menu_app-googlesearch.svg","template":{"template":"<script>(function() {var cx = '{{id}}'; var gcse = document.createElement('script'); gcse.type = 'text/javascript'; gcse.async = true; gcse.src = 'https://cse.google.com/cse.js?cx=' + cx; var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(gcse, s);})(); </script><gcse:search></gcse:search>","preload":"assets/scripts/googleSearch.js"},"fields":[{"type":"String","fallback":"","label":"Google Search ID","id":"id","required":true,"hidden":false},{"type":"Number","fallback":300,"label":"Width","id":"width","hidden":true,"required":true,"max":1200},{"type":"Number","fallback":20,"label":"Height","id":"height","hidden":true,"required":true,"max":1200}],"styles":{"height":"auto","minHeight":"50px"}},"youtube":{"id":"youtube","title":"YouTube","tab":"Video","ui_template":"html","general_help":"<div>For Video please type the youtube ID - Last sequence of the video URL (eg: http://youtube/<b>6RWC7BSUseQB</b></div>","preview_file":"sm_inline_menu_app-youtube.svg","contains_iframe":true,"keep_aspect_ratio":true,"drag_placeholder":"sm_draggable_placeholder-youtube.svg","template":{"template":"<iframe width='{{width}}' height='{{height}}' src='https://www.youtube.com/embed/{{query}}/{{yt_thumbnail}}' frameborder='0' allowfullscreen=''></iframe>"},"fields":[{"type":"String","fallback":"DLEWW0LCBFc","label":"Video","id":"query","validation":[{"type":"Regex","value":"^([_A-Za-z0-9- '])+$","error":"invalid youtube id"}],"required":true},{"type":"Number","fallback":300,"label":"Width","id":"width","hidden":true,"min":0,"max":1080,"required":false},{"type":"Number","fallback":300,"hidden":true,"label":"Height","id":"height","min":0,"max":1080,"required":false}],"classes":["embed-responsive","embed-responsive-16by9"]},"vimeo":{"id":"vimeo","title":"Vimeo","tab":"Video","ui_template":"html","general_help":"<div>For Video please type the Vimeo ID - Last sequence of the video URL (eg: http://vimeo/<b>120920678</b></div>","preview_file":"sm_inline_menu_app-vimeo.svg","contains_iframe":true,"keep_aspect_ratio":true,"drag_placeholder":"sm_draggable_placeholder-vimeo.svg","template":{"template":"<iframe width='{{width}}' height='{{height}}' src='https://player.vimeo.com/video/{{query}}' frameborder='0' allowfullscreen=''></iframe>"},"fields":[{"type":"String","fallback":"226201181","label":"Video","id":"query","validation":[{"type":"Regex","value":"^([0-9])+$"}],"required":true},{"type":"Number","fallback":300,"label":"Width","id":"width","hidden":true,"min":0,"max":1080,"required":false},{"type":"Number","fallback":300,"hidden":true,"label":"Height","id":"height","min":0,"max":1080,"required":false}],"classes":["embed-responsive","embed-responsive-16by9"]},"twitter_timeline":{"id":"twitter_timeline","title":"Twitter Timeline","tab":"Social","ui_template":"html","general_help":"<div>Embed your Twitter page on your site.</br></br> <ul> <li>Go to the Twitter page you’d like to embed. Copy the URL from the address bar, e.g. http://twitter.com/MyBakeryWebsite </li> <li>Paste the URL in the field above and click 'Apply'.</li> <li>Add a title to the Fallback link field above that will be displayed as a link to your Twitter page if we cannot display the timeline</li></ul> </div>","preview_file":"sm_inline_menu_app-twitter.svg","template":{"template":"<a class=\"twitter-timeline\" href=\"https://twitter.com/{{timelineid}}\">{{fallback}}</a>","preload":"https://platform.twitter.com/widgets.js"},"fields":[{"type":"String","fallback":"MyBakeryWebsite","label":"Twitter Feed","id":"timelineid","required":true,"hidden":false},{"type":"String","fallback":"Tweets by Bakery 8","label":"Fallback link","id":"fallback","required":true,"hidden":false},{"type":"Number","fallback":300,"label":"Width","id":"width","hidden":true,"min":0,"max":1200,"required":true},{"type":"Number","fallback":300,"label":"Height","id":"height","hidden":true,"min":0,"max":1200,"required":true}],"classes":["embed-responsive","embed-responsive-16by9"],"styles":{"overflowY":"scroll"}},"GoogleCalendar":{"id":"GoogleCalendar","title":"Google Calendar","tab":"Tools","ui_template":"html","general_help":"<div>How to locate your calendar ID:<ul> <li>Go to Google <a href=\"https://calendar.google.com/\" target=\"_blank\" >Calendar</a>.</li><li>Click the cog icon in the top left > Settings.</li><li>Choose the ‘Calendars’ tab and click to select a calendar from the list.</li><li>Click the ‘Share this Calendar’ tab and make sure the ‘Make this calendar public’ box is checked.</li><li>Go back to the ‘Calendar Details’ tab and copy the Calendar ID from the ‘Calendar Address’ section.</li></ul></div>","preview_file":"sm_inline_menu_app-google-calendar.svg","contains_iframe":true,"keep_aspect_ratio":true,"drag_placeholder":"sm_draggable_placeholder-googlecalendar.svg","template":{"template":"<iframe src=\"https://calendar.google.com/calendar/embed?src={{email}}&title={{title}} \" style=\"border-width:0\" width=\"{{width}}\" height=\"{{height}}\" frameborder=\"0\" scrolling=\"no\"></iframe>"},"fields":[{"type":"String","fallback":"","label":"Google Calendar ID","id":"email","required":true},{"type":"Number","fallback":800,"label":"Width","id":"width","hidden":true,"min":0,"max":1200,"required":true},{"type":"Number","fallback":600,"label":"Height","id":"height","hidden":true,"min":0,"max":1200,"required":true}],"classes":["embed-responsive","embed-responsive-16by9"]},"spotift-p":{"id":"spotift-p","title":"Spotify Playlist","tab":"Music","ui_template":"html","general_help":"<div>Enter the Spotify URI to add a play button (e.g. <b>spotify:artist:45lorWzrKLxfKlWpV7r9CN).</b></br></br>You can find the URI in the Spotify application. Click on the ‘More’ button (the circle icon containing three dots) and click ‘Copy Spotify URI’.</br>You can then paste this into the entry box for this app.</div>","preview_file":"sm_inline_menu_app-spotifyplaylist.svg","contains_iframe":true,"keep_aspect_ratio":true,"drag_placeholder":"sm_draggable_placeholder-spotifyplaylist.svg","template":{"template":"<iframe src=\"https://embed.spotify.com/?uri={{url}}\" width=\"{{width}}\" height=\"{{height}}\" frameborder=\"0\" allowtransparency=\"true\"></iframe>"},"fields":[{"type":"String","fallback":"spotify:artist:45lorWzrKLxfKlWpV7r9CN","label":"Spotify URI","id":"url","required":true},{"type":"Number","fallback":300,"label":"Width","id":"width","min":0,"max":1200,"required":false,"hidden":true},{"type":"Number","fallback":200,"label":"Height","id":"height","min":0,"max":1200,"required":false,"hidden":true}],"classes":["embed-responsive","embed-responsive-16by9"]},"spotify":{"id":"spotify","title":"Spotify Follow","tab":"Music","ui_template":"html","general_help":"<div>Enter the artists Spotify ID to add a follow button (e.g. <b>1vCWHaC5f2uS3yhpwWbIA6</b>).</br></br>You can find the artist ID in the Spotify application. Click on the ‘More’ button (the circle icon containing three dots) and click ‘Copy Spotify URI’.</br>You can then paste this into the entry box for this app (spotify:artist:1vCWHaC5f2uS3yhpwWbIA6) and remove the ‘spotify:artist:’ part to leave the artist ID.</div>","preview_file":"sm_inline_menu_app-spotifyfollow.svg","contains_iframe":true,"drag_placeholder":"sm_draggable_placeholder-spotifyfollow.svg","template":{"template":"<iframe src=\"https://embed.spotify.com/follow/1/?uri={{url}}&size=detail&theme=light\" width=\"300\" height=\"56\" scrolling=\"no\" frameborder=\"0\" style=\"border:none; overflow:hidden;\" allowtransparency=\"true\"></iframe>"},"fields":[{"type":"String","fallback":"spotify:artist:1vCWHaC5f2uS3yhpwWbIA6","label":"Spotify Artist URI","id":"url","required":true},{"type":"Number","fallback":300,"label":"Width","id":"width","hidden":true,"min":0,"max":1200,"required":false},{"type":"Number","fallback":200,"label":"Height","id":"height","hidden":true,"min":0,"max":1200,"required":false}]},"soundcloud":{"id":"soundcloud","title":"Soundcloud Player","tab":"Music","ui_template":"html","general_help":"<div>Enter the name of the artist or the path of the playlist or song from the Soundclound.com URL, e.g: \nartist \nartist/song\nartist/playlist</div>","preview_file":"sm_inline_menu_app-soundcloudplayer.svg","contains_iframe":true,"keep_aspect_ratio":true,"drag_placeholder":"sm_draggable_placeholder-soundcloud.svg","template":{"template":"<iframe width=\"{{width}}\" height=\"{{height}}\" scrolling=\"no\" frameborder=\"no\" src=\"https://w.soundcloud.com/player/?url=https://soundcloud.com/{{url}}&amp;auto_play=false&amp;hide_related=false&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false&amp;visual=true\"></iframe>"},"fields":[{"type":"String","fallback":"glenn-gould/glenn-gould-on-bach-in-german","label":"Title","id":"url","required":true},{"type":"Number","fallback":300,"label":"Width","id":"width","hidden":true,"min":0,"max":1200,"required":false},{"type":"Number","fallback":200,"label":"Height","id":"height","hidden":true,"min":0,"max":1200,"required":false}],"classes":["embed-responsive","embed-responsive-16by9"]},"wordpress":{"id":"wordpress","title":"Wordpress","tab":"Tools","ui_template":"html","general_help":"<div>Enter your wordpress subdomain, e.g http://[subdomain].wordpress.com.</div>","preview_file":"sm_inline_menu_app-wordpress.svg","contains_iframe":true,"keep_aspect_ratio":true,"drag_placeholder":"sm_draggable_placeholder-wordpress.svg","template":{"template":"<iframe width=\"{{width}}\" height=\"{{height}}\" src=\"https://{{name}}.wordpress.com\" frameborder=\"0\" allowfullscreen></iframe>"},"fields":[{"type":"String","fallback":"reef494","label":"Wordpress subdomain","id":"name","required":true},{"type":"Number","fallback":300,"label":"Width","id":"width","hidden":true,"min":0,"max":1200,"required":false},{"type":"Number","fallback":200,"label":"Height","id":"height","hidden":true,"min":0,"max":1200,"required":false}],"classes":["embed-responsive","embed-responsive-16by9"]},"eu_cookie":{"id":"eu_cookie","title":"Cookie Banner","tab":"Tools","ui_template":"html","general_help":"<div><p>You can change the banner title and main text using the relevant fields above.</p><p>Policy URL:<br />We have included a default cookie policy which you can keep, but we advise that you create your own policy using ours for guidance (this will appear when a visitor clicks on the 'Details' link in the banner).</p><p>Create a new page in your site, named 'Cookies Policy' for example, and add your policy details. You can then insert the end of the page URL in the URL field, as shown above. Make sure to include the forward slash!</p></div>","preview_file":"sm_inline_menu_app-cookiebanner.svg","template":{"template":"<section><div class=\"cookie-sm\" id=\"main\" style=\"text-align: left;position:relative; background: {{background}}; color: {{maincolor}}; padding-top: 10px; padding-right: 10px; padding-bottom: 10px; padding-left: 10px;\"> <div style=\"width:80%; padding:10px \"> <div style=\"font-family: sans-serif; text-align: left;font-size:{{size}}px; color: {{titleTextColor}}\" >{{website}}</div> <div style=\"font-family: sans-serif; font-size:{{size}}px; text-align: left; color: {{mainColor}}\" >{{mainLabel}}</div> </div> <div style=\"font-family: sans-serif; font-size:{{size}}px; text-align: right; width:20%; position:absolute; right:10px; bottom:5px\" > <a  style=\"color: {{titleTextColor}}\" href=\"#\" id=\"click_me\" onclick=\"cooke(event)\">Accept</a> <a style=\"color: {{titleTextColor}}; padding-left: 10px\" href=\"#\" onclick=\"gohref(event)\" >Details</a> </div> </div> </section><script type=\"text/javascript\" defer>function gohref (event){var userValue =\"{{{policyUrl}}}\";var url = window.location.protocol + \"//\"+window.location.host+userValue; window.open(url,'_blank');}; function cooke(event) { var elements = document.getElementsByClassName(\"cookie-sm\");;var i; for (i = 0; i < elements.length; i++) {var element = elements[i]; element.style.display = 'none'; }; document.cookie = \"eu-cookie=true; path=/\"; } function getCookie(cname) { var name = cname + \"=\"; var ca = document.cookie.split(';'); for (var i = 0; i < ca.length; i++) { var c = ca[i]; while (c.charAt(0) == ' ') { c = c.substring(1); } if (c.indexOf(name) == 0) { return c.substring(name.length, c.length); } } return \"\"; } var cookieEU = getCookie(\"eu-cookie\"); if (cookieEU != \"\") { var elements = document.getElementsByClassName(\"cookie-sm\");var i; for (i = 0; i < elements.length; i++) { var element = elements[i]; element.style.display = 'none'; }} else { var elements = document.getElementsByClassName(\"cookie-sm\");var i; for (i = 0; i < elements.length; i++) { var element = elements[i]; element.style.display = 'block'; } } </script>"},"fields":[{"type":"Color","fallback":"#9f9f9f","label":"Background","id":"background","required":true},{"type":"Color","fallback":"#000000","label":"Title text","id":"titleTextColor","required":true},{"type":"Color","fallback":"#f0f0f0","label":"Main text","id":"mainColor","required":true},{"type":"String","fallback":"Cookie usage on this website","label":"Banner title","id":"website","required":true},{"type":"String","fallback":"We use cookies to ensure that we give you the best experience on our website. We'll assume that you are happy to receive all cookies on this website.","label":"Main text","id":"mainLabel","required":true},{"type":"Slider","fallback":16,"label":"Font size","id":"size","min":1,"max":30,"required":true},{"type":"String","fallback":"/cookies-privacy/sitemaker-cookies.html","label":"Policy URL","id":"policyUrl","required":true,"validation":[{"type":"Regex","value":"^\\/(([A-z0-9\\-\\%.]+\\/)*[A-z0-9\\-\\%.]+$)+"}]}],"styles":{"height":"auto"}},"photosnack_slideshow":{"id":"photosnack_slideshow","title":"PhotoSnack","tab":"Tools","ui_template":"html","general_help":"<div>Add a PhotoSnack slideshow to your website.</br></br> <ul> <li>Add images to your slideshow <a href=\"http://www.photosnack.com/photo-slideshow-maker-html/quick-upload\" target=\"_blank\">here</a>, then click ‘Next’. </li> <li>Give your slideshow a title and description and click 'Finish'. If you don't have a 'Finish' button, you'll have an option to sign up with Facebook or email instead.</li> <li>You should now be on the album page. Copy the characters after \"/details/\" and before the \"?\" in the URL e.g. pd13bjijo.</li> <li>Paste these characters in the field above..</li></div>","preview_file":"sm_inline_menu_app-photosnack.svg","contains_iframe":true,"keep_aspect_ratio":true,"drag_placeholder":"sm_draggable_placeholder-photosnack.svg","template":{"template":"<iframe style=\"border:none\" src=\"http://files.photosnack.com/iframejs/embed.html?hash={{id}}&t=1466513257\" width=\"{{width}}\" height=\"{{height}}\" allowfullscreen=\"true\" mozallowfullscreen=\"true\" webkitallowfullscreen=\"true\" ></iframe>"},"fields":[{"type":"String","fallback":"pd13bjijo","label":"Photosnack ID","id":"id","required":true,"hidden":false,"validation":[{"type":"Regex","value":"^([A-Za-z0-9])+$"}]},{"type":"Number","fallback":300,"label":"Width","id":"width","hidden":true,"min":0,"max":1200,"required":true},{"type":"Number","fallback":200,"label":"Height","id":"height","hidden":true,"min":0,"max":1200,"required":true}],"classes":["embed-responsive","embed-responsive-16by9"]},"wufoo_form":{"id":"wufoo_form","title":"Wufoo Form","tab":"Forms","ui_template":"html","general_help":"<div>Add a Wufoo contact form to your page.</br></br> <ul> <li>Create your Wufoo form <a href=\"http://www.wufoo.com/form-builder/\" target=\"_blank\">here.</a></li> <li>Once you’ve built your form, click ‘Share Form’.</li> <li>From the ‘Permanent Link’ field, copy the characters after /forms/ in the URL e.g. zle733g08ey41p</li> <li>Paste these characters under ‘Wufoo ID’ above and add your username in the ‘Wufoo Username’ field.</li></ul></div>","preview_file":"sm_inline_menu_app-wufoo.svg","template":{"template":"<div id=\"wufoo-{{id}}\" style=\"height:{{height}}px\"> Fill out my <a href=\"https://{{userName}}.wufoo.com/forms/{{id}}\">online form</a>.<div id=\"wuf-adv\" style=\"font-family:inherit;font-size: small;color:#a7a7a7;text-align:center;display:block;position:absolute;bottom:0\">Use <a href=\"http://www.wufoo.com/gallery/templates/\">Wufoo templates</a> to make your own HTML forms.</div></div><script type=\"text/javascript\">var {{id}};(function(d, t) { var s = d.createElement(t), options = { 'userName':'{{userName}}', 'formHash':'{{id}}', 'autoResize':true, 'height':'{{height}}', 'async':true, 'host':'wufoo.com', 'header':'show', 'ssl':true}; s.src = ('https:' == d.location.protocol ? 'https://' : 'http://') + 'www.wufoo.com/scripts/embed/form.js'; s.onload = s.onreadystatechange = function() { var rs = this.readyState; if (rs) if (rs != 'complete') if (rs != 'loaded') return; try { {{id}} = new WufooForm();{{id}}.initialize(options);{{id}}.display(); } catch (e) {}}; var scr = d.getElementsByTagName(t)[0], par = scr.parentNode; par.insertBefore(s, scr); })(document, 'script');</script>","preload":"assets/scripts/wufooFormScript.js"},"fields":[{"type":"String","fallback":"","label":"Wufoo ID","id":"id","required":true,"hidden":false},{"type":"String","fallback":"","label":"Wufoo Username","id":"userName","required":true},{"type":"Number","fallback":300,"label":"Width","id":"width","hidden":true,"min":0,"max":1200,"required":true},{"type":"Number","fallback":312,"label":"Height","id":"height","min":0,"max":1200,"required":true,"validation":{"type":"Num","min":0,"max":1200,"error":"Value must be between 0 and 1200"}}],"styles":{"height":"auto"}},"google_form":{"id":"google_form","title":"Google Form","tab":"Forms","ui_template":"html","general_help":"<div>Add a Google Form to your page<br /><ul><li>Create your Google Form</li><li>Once you've built your form, click \"Send\"</li><li>Click the hyperlink icon to get the form link</li><li>Copy the characters between \"/forms/d/e/\" and \"/viewform?usp=sf_link\" e.g. \"1FBIpQLDeKuqC4vM9UCy-4tcUIyQyVfuuhU4LExPFoSdG3qTleoAk3gg\"<li>Paste the link under \"Google Form Link\"</li><ul>","preview_file":"sm_inline_menu_app-google_form.svg","contains_iframe":true,"keep_aspect_ratio":true,"drag_placeholder":"sm_inline_menu_app-google_form.svg","template":{"template":"<div>{{#id}}<iframe src=\"https://docs.google.com/forms/d/e/{{id}}/viewform?embedded=true\" width=\"100%\" height=\"900\" frameborder=\"0\" marginheight=\"0\" marginwidth=\"0\">Loading...</iframe>{{/id}}{{^id}}<div style=\"border: 2px solid grey\">No Google Form ID set</div>{{/id}}</div>"},"fields":[{"type":"String","fallback":"","label":"Google Form Link","id":"id","required":true,"hidden":false}],"styles":{"height":"auto"},"classes":["embed-responsive","embed-responsive-16by9"]},"facebook_page":{"id":"facebook_page","title":"Facebook Page","tab":"Social","ui_template":"html","general_help":"<div>Embed your Facebook page on your site. If you don’t have a page set up, you can create one <a href=\"http://www.facebook.com/pages/create/\" target=\"_blank\">here.</a> </br></br> <ul> <li>In your Facebook page settings, remove any Country Restrictions, Age Restrictions, or other restrictions that may be <a href=\"https://www.facebook.com/help/150193685051184\" target=\"_blank\">blocking access</a></li><li>Go to your Facebook page and from your browser address bar copy the part of the URL after “www.facebook.com/“ e.g. <b>My-Bakery-Website-651950401623247</b> </li><li>Please note, the Facebook recommended mininum dimensions are 300px width, 180px height.</li><li>Please note, the Facebook recommended maximum dimensions are 500px width, 1200px height.</li> </ul> </div>","preview_file":"sm_inline_menu_app-facebook.svg","contains_iframe":true,"drag_placeholder":"sm_draggable_placeholder-facebook.svg","template":{"template":"<div class=\"fb-page\" data-href=\"https://www.facebook.com/{{url}}?appId={{id}}\" data-tabs=\"timeline\" data-small-header=\"false\" data-hide-cover=\"false\" data-width=\"{{width}}\" data-height=\"{{height}}\" data-adapt-container-width=\"true\" data-show-facepile=\"true\"><blockquote cite=\"https://www.facebook.com/{{url}}\" class=\"fb-xfbml-parse-ignore\"><a href=\"https://www.facebook.com/{{url}}\">{{page}}</a></blockquote></div>","preload":"https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.8"},"fields":[{"type":"String","fallback":"My-Bakery-Website-651950401623247","label":"Facebook Page","id":"url","required":true,"hidden":false},{"type":"String","fallback":"104983919608527","label":"Facebook Application id","id":"id","required":true,"hidden":true},{"type":"String","fallback":"Your page","label":"Link label for your page","id":"page","required":false,"hidden":true},{"type":"Number","fallback":300,"label":"Width","id":"width","hidden":false,"min":180,"max":500,"required":true,"validation":{"type":"Num","min":180,"max":500,"error":"Value must be between 180 and 500"}},{"type":"Number","fallback":500,"label":"Height","id":"height","hidden":false,"min":130,"max":2000,"required":true,"validation":{"type":"Num","min":130,"max":2000,"error":"Value must be between 130 and 2000"}}],"styles":{"height":"auto","minHeight":130}},"facebook_comment":{"id":"facebook_comment","title":"Facebook Comment","tab":"Social","ui_template":"html","general_help":"<div>Add your site URL in the field above (including the http:// prefix).</div>","preview_file":"sm_inline_menu_app-facebook.svg","contains_iframe":true,"keep_aspect_ratio":true,"drag_placeholder":"sm_draggable_placeholder-facebook.svg","template":{"template":"<div class=\"fb-comments\" data-href=\"{{url}}\" width={{width}} data-numposts=\"{{comments}}\"></div>","preload":"https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.8"},"fields":[{"type":"String","fallback":"https://www.facebook.com/","label":"URL to comment","id":"url","required":true,"hidden":false},{"type":"String","fallback":"104983919608527","label":"Facebook Application id","id":"id","required":true,"hidden":true},{"type":"Number","fallback":5,"label":"Number of comments","id":"comments","required":true,"hidden":true},{"type":"Number","fallback":"100%","label":"Width","id":"width","hidden":true,"min":180,"max":500,"required":true},{"type":"Number","fallback":300,"label":"Height","id":"height","hidden":true,"min":200,"max":1200,"required":true}],"styles":{"background":"white","overflowY":"scroll"},"classes":["embed-responsive","embed-responsive-16by9"]},"facebook_like":{"id":"facebook_like","title":"Facebook Like","tab":"Social","ui_template":"html","general_help":"<div>Enter the URL of the page you want the Like/Share button to link to (e.g. your website address).</div>","preview_file":"sm_inline_menu_app-facebook-like.svg","template":{"template":"<div class=\"fb-like\" data-action=\"like\" data-href=\"{{url}}\" data-layout=\"{{layout}}\" data-size=\"{{size}}\" data-colorscheme=\"{{colorScheme}}\" data-width=\"{{width}}px\" data-show-faces=\"true\" data-share=\"{{shareButton}}\"></div>","preload":"https://connect.facebook.net/en_US/all.js#xfbml=1&version=v2.8"},"fields":[{"type":"String","fallback":"https://www.facebook.com","label":"URL to like","id":"url","required":true,"hidden":false},{"type":"Select","fallback":"standard","label":"Layout","id":"layout","options":[{"value":"standard","label":"Standard"},{"value":"button_count","label":"Button count"},{"value":"button","label":"Button"},{"value":"box_count","label":"Box count"}],"required":true},{"type":"Select","fallback":"small","label":"Size","id":"size","options":[{"value":"small","label":"Small"},{"value":"large","label":"Large"}],"required":true,"hidden":true},{"type":"Select","fallback":"light","label":"Scheme","id":"colorScheme","options":[{"value":"light","label":"Light"},{"value":"dark","label":"Dark"}],"required":true,"hidden":true,"showIf":{"key":"layout","value":"standard"}},{"type":"Number","fallback":"450","label":"Width (px)","id":"width","min":225,"validation":{"type":"Num","min":225,"error":"Minimum width is 225px"},"required":true,"hidden":true,"showIf":{"key":"layout","value":"standard"}},{"type":"Checkbox","fallback":false,"label":"Include share button","id":"shareButton","required":false}],"styles":{"height":"auto"}},"instagram_img":{"id":"instagram_img","title":"Instagram","tab":"Social","preview_file":"sm_inline_menu_app-instagram.svg","ui_template":"html","general_help":"<div><p>Copy the embed code from the instagram post you want to include. Then just paste it into the box above and click apply.</p><p>The post image will be viewable when you visit your site.</p></div>","template":{"template":"{{{html}}}","preload":"https://platform.instagram.com/en_US/embeds.js"},"fields":[{"type":"TextArea","placeholder":"paste your instagram embed code here","label":"Embed code","id":"html","height":"12","required":true,"button":"Apply"}],"styles":{"height":"auto","minHeight":"50px"}},"pinterest_pin":{"id":"pinterest_pin","title":"Pinterest Pin It","tab":"Social","preview_file":"sm_inline_menu_app-pinterest.svg","ui_template":"html","general_help":"This widget does not require any configuration. \nThe button will display on your site as presented here.","template":{},"fields":[{"type":"Select","fallback":"gray","label":"Colour","id":"color","options":[{"value":"gray","label":"Gray"},{"value":"red","label":"Red"},{"value":"white","label":"White"}],"required":false,"hidden":true},{"type":"Checkbox","fallback":false,"label":"Large","id":"large","required":false,"hidden":true},{"type":"Checkbox","fallback":false,"label":"Round","id":"round","required":false,"hidden":true}],"styles":{"height":"auto"}},"chatango":{"id":"chatango","title":"Chatango","tab":"Social","preview_file":"sm_inline_menu_app-chatango.svg","general_help":"<div><p>Copy the embed code from your Chatango widget then paste it in the box above and click apply.</p><p>Note that the Chatango 'Tab' option will not be viewable in the editor but will be visible when you view your published site.</p></div>","template":{"template":"{{{html}}}"},"fields":[{"type":"TextArea","placeholder":"Find Share/Embed on site, copy code begining with <iframe, <script or <class","label":"Snippet","id":"html","height":"12","required":true,"button":"Apply"},{"type":"Link","id":"get_snippet","label":"Get Snippet","href":"http://chatango.com/"}],"styles":{"height":"auto"},"classes":["embed-responsive","embed-responsive-16by9"]},"html_snippet":{"id":"html_snippet","title":"HTML Snippet","tab":"Tools","preview_file":"sm_inline_icons_trans-snippet.svg","contains_iframe":true,"drag_placeholder":"sm_draggable_placeholder-htmlsnippet.svg","template":{"template":"{{{html}}}"},"fields":[{"type":"TextArea","fallback":"...you can enter your own html snippet in here!","label":"HTML","id":"html","height":"12","required":true,"button":"Apply"}],"styles":{"height":"auto"}},"form":{"id":"form","title":"Form","type":"form","tab":"Forms","preview_file":"sm_inline_icons_trans-form.svg","template":{},"fields":[],"styles":{"height":"auto"}},"rss_feed":{"id":"rss_feed","title":"RSS Feed","type":"rss_feed","tab":"Tools","preview_file":"sm_inline_menu_app-rss.svg","contains_iframe":true,"drag_placeholder":"sm_draggable_placeholder-rss.svg","template":{},"fields":[{"type":"String","fallback":"https://www.wired.com/feed/","label":"RSS Feed URL","id":"url","tooltip":"To find an RSS feed URL: Go to the website, right-click and click view page source. Search 'rss' and copy the feed's URL address found between the quotes after href=","required":true},{"type":"Select","fallback":"grid","label":"Layout","id":"layout","options":[{"value":"list","label":"List"},{"value":"grid","label":"Grid"},{"value":"magazine","label":"Magazine"}],"required":true},{"type":"Number","fallback":4,"label":"Max Post Number","id":"post-limit","min":1,"max":50,"required":true},{"type":"Number","fallback":300,"label":"Description Character Limit","id":"character-limit","min":1,"max":10000,"required":true},{"type":"Number","fallback":2,"label":"Grid Columns","id":"grid-columns","min":1,"max":5,"required":true},{"type":"Slider","fallback":20,"label":"Article Spacing","id":"article-spacing","min":0,"max":100,"step":10,"required":true},{"type":"Checkbox","fallback":true,"label":"Display images","id":"display-images","required":true},{"type":"Checkbox","fallback":true,"label":"Display Author & Timestamp","id":"display-auth-timestamp","required":true}],"styles":{"height":"auto"}}}

/***/ }),

/***/ 11:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return IMAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return VIDEO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return GALLERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return COLUMN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return ROW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BUTTON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return NAVBAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return NAVITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ICON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SOCIAL_ICONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SPACER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DIVIDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return INLINE_APP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FORM_BUTTON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return INPUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return TEXTAREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHECKBOX_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return RADIO_BUTTON_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return RECAPTCHA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return REQUIRED_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DRAGGABLE_FORM_ELEMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DRAGGABLE_COL_ELEMENTS; });
/* unused harmony export HELP_LINKS */
/* unused harmony export YELL_HELP_LINKS */
/* harmony export (immutable) */ __webpack_exports__["A"] = getHelpLinkForElementType;
var TEXT = "text";
var IMAGE = "image";
var VIDEO = "video";
var GALLERY = "gallery";
var COLUMN = "col";
var ROW = "row";
var BUTTON = "button";
var SECTION = "container";
var NAVBAR = "navbar";
var NAVITEM = "navitem";
var ICON = "icon";
var SOCIAL_ICONS = "socialIcons";
var SPACER = "spacer";
var DIVIDER = "divider";
var INLINE_APP = "inlineApp";
var FORM = "form";
var FORM_BUTTON = "formButton";
var INPUT = "input";
var SELECT = "select";
var TEXTAREA = "textarea";
var CHECKBOX_GROUP = "checkboxGroup";
var RADIO_BUTTON_GROUP = "radioButtonGroup";
var RECAPTCHA = "recaptcha";
var REQUIRED_LABEL = "requiredLabel";

var DRAGGABLE_FORM_ELEMENTS = [FORM_BUTTON, INPUT, SELECT, TEXTAREA, CHECKBOX_GROUP, RADIO_BUTTON_GROUP, RECAPTCHA, REQUIRED_LABEL];

var DRAGGABLE_COL_ELEMENTS = [TEXT, IMAGE, VIDEO, GALLERY, BUTTON, ICON, SOCIAL_ICONS, SPACER, DIVIDER, INLINE_APP, FORM];

var HELP_LINKS = {
  "col": "http://help.moonfruit.com/responsive-editor/getting-started/responsive-editor-editing-the-page-layout",
  "row": "http://help.moonfruit.com/responsive-editor/getting-started/responsive-editor-editing-the-page-layout",
  "container": "http://help.moonfruit.com/responsive-pages-beta/guides/addingarranging-a-section",
  "image": "http://help.moonfruit.com/responsive-pages-beta/guides/adding-an-image",
  "icon": "http://help.moonfruit.com/responsive-pages-beta/guides/adding-an-icon",
  "text": "http://help.moonfruit.com/responsive-pages-beta/guides/addingediting-a-text-box",
  "button": "http://help.moonfruit.com/responsive-pages-beta/guides/addingediting-a-link-button",
  "navbar": "http://help.moonfruit.com/responsive-pages-beta/guides/editing-the-page-menu",
  "gallery": "http://help.moonfruit.com/responsive-pages-beta/guides/adding-a-slideshow-or-gallery",
  "inlineApp": "http://help.moonfruit.com/the-responsive-editor-beta#widgets",
  "socialIcons": "http://help.moonfruit.com/the-responsive-editor-beta/widgets/responsive-editor-adding-social-icons",
  "spacer": "http://help.moonfruit.com/responsive-pages-beta/guides/adding-a-spacer-or-divider",
  "divider": "http://help.moonfruit.com/responsive-pages-beta/guides/adding-a-spacer-or-divider",
  "form": "http://help.moonfruit.com/responsive-pages-beta/guides/adding-a-contact-form"
};

var YELL_HELP_LINKS = {
  "image": "http://intercom.help/yellsites/images/add-an-image",
  "icon": "http://intercom.help/yellsites/build-your-websitesite-with-the-responsive-editor/add-an-icon",
  "text": "http://intercom.help/yellsites/build-your-websitesite-with-the-responsive-editor/add-a-text-box",
  "button": "http://intercom.help/yellsites/build-your-websitesite-with-the-responsive-editor/add-a-link-button",
  "gallery": "http://intercom.help/yellsites/images/add-an-image-gallery",
  "socialIcons": "http://intercom.help/yellsites/social/add-social-icons",
  "spacer": "http://intercom.help/yellsites/build-your-websitesite-with-the-responsive-editor/spacer-or-page-divider",
  "divider": "http://intercom.help/yellsites/build-your-websitesite-with-the-responsive-editor/spacer-or-page-divider",
  "form": "http://intercom.help/yellsites/build-your-websitesite-with-the-responsive-editor/add-a-moonfruit-and-wufoo-contact-form"
};

function getHelpLinkForElementType(type, partnerCode) {
  switch (partnerCode) {
    case 'yell':
      return YELL_HELP_LINKS[type] ? YELL_HELP_LINKS[type] : null;
      break;
    case 'moonfruit':
      return HELP_LINKS[type] ? HELP_LINKS[type] : null;
      break;
    default:
      return HELP_LINKS[type] ? HELP_LINKS[type] : null;
  }
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TEXT, "TEXT", "/usr/src/app/src/constants/ElementTypes.js");

  __REACT_HOT_LOADER__.register(IMAGE, "IMAGE", "/usr/src/app/src/constants/ElementTypes.js");

  __REACT_HOT_LOADER__.register(VIDEO, "VIDEO", "/usr/src/app/src/constants/ElementTypes.js");

  __REACT_HOT_LOADER__.register(GALLERY, "GALLERY", "/usr/src/app/src/constants/ElementTypes.js");

  __REACT_HOT_LOADER__.register(COLUMN, "COLUMN", "/usr/src/app/src/constants/ElementTypes.js");

  __REACT_HOT_LOADER__.register(ROW, "ROW", "/usr/src/app/src/constants/ElementTypes.js");

  __REACT_HOT_LOADER__.register(BUTTON, "BUTTON", "/usr/src/app/src/constants/ElementTypes.js");

  __REACT_HOT_LOADER__.register(SECTION, "SECTION", "/usr/src/app/src/constants/ElementTypes.js");

  __REACT_HOT_LOADER__.register(NAVBAR, "NAVBAR", "/usr/src/app/src/constants/ElementTypes.js");

  __REACT_HOT_LOADER__.register(NAVITEM, "NAVITEM", "/usr/src/app/src/constants/ElementTypes.js");

  __REACT_HOT_LOADER__.register(ICON, "ICON", "/usr/src/app/src/constants/ElementTypes.js");

  __REACT_HOT_LOADER__.register(SOCIAL_ICONS, "SOCIAL_ICONS", "/usr/src/app/src/constants/ElementTypes.js");

  __REACT_HOT_LOADER__.register(SPACER, "SPACER", "/usr/src/app/src/constants/ElementTypes.js");

  __REACT_HOT_LOADER__.register(DIVIDER, "DIVIDER", "/usr/src/app/src/constants/ElementTypes.js");

  __REACT_HOT_LOADER__.register(INLINE_APP, "INLINE_APP", "/usr/src/app/src/constants/ElementTypes.js");

  __REACT_HOT_LOADER__.register(FORM, "FORM", "/usr/src/app/src/constants/ElementTypes.js");

  __REACT_HOT_LOADER__.register(FORM_BUTTON, "FORM_BUTTON", "/usr/src/app/src/constants/ElementTypes.js");

  __REACT_HOT_LOADER__.register(INPUT, "INPUT", "/usr/src/app/src/constants/ElementTypes.js");

  __REACT_HOT_LOADER__.register(SELECT, "SELECT", "/usr/src/app/src/constants/ElementTypes.js");

  __REACT_HOT_LOADER__.register(TEXTAREA, "TEXTAREA", "/usr/src/app/src/constants/ElementTypes.js");

  __REACT_HOT_LOADER__.register(CHECKBOX_GROUP, "CHECKBOX_GROUP", "/usr/src/app/src/constants/ElementTypes.js");

  __REACT_HOT_LOADER__.register(RADIO_BUTTON_GROUP, "RADIO_BUTTON_GROUP", "/usr/src/app/src/constants/ElementTypes.js");

  __REACT_HOT_LOADER__.register(RECAPTCHA, "RECAPTCHA", "/usr/src/app/src/constants/ElementTypes.js");

  __REACT_HOT_LOADER__.register(REQUIRED_LABEL, "REQUIRED_LABEL", "/usr/src/app/src/constants/ElementTypes.js");

  __REACT_HOT_LOADER__.register(DRAGGABLE_FORM_ELEMENTS, "DRAGGABLE_FORM_ELEMENTS", "/usr/src/app/src/constants/ElementTypes.js");

  __REACT_HOT_LOADER__.register(DRAGGABLE_COL_ELEMENTS, "DRAGGABLE_COL_ELEMENTS", "/usr/src/app/src/constants/ElementTypes.js");

  __REACT_HOT_LOADER__.register(HELP_LINKS, "HELP_LINKS", "/usr/src/app/src/constants/ElementTypes.js");

  __REACT_HOT_LOADER__.register(YELL_HELP_LINKS, "YELL_HELP_LINKS", "/usr/src/app/src/constants/ElementTypes.js");

  __REACT_HOT_LOADER__.register(getHelpLinkForElementType, "getHelpLinkForElementType", "/usr/src/app/src/constants/ElementTypes.js");
}();

;

/***/ }),

/***/ 13:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = getElementAtPath;
/* harmony export (immutable) */ __webpack_exports__["h"] = getElementParent;
/* harmony export (immutable) */ __webpack_exports__["o"] = getSelectedElement;
/* harmony export (immutable) */ __webpack_exports__["k"] = getModel;
/* harmony export (immutable) */ __webpack_exports__["b"] = elementTypeFriendlyName;
/* harmony export (immutable) */ __webpack_exports__["l"] = getPartnerPath;
/* harmony export (immutable) */ __webpack_exports__["j"] = getModeStyleKey;
/* harmony export (immutable) */ __webpack_exports__["s"] = getStylePropertyClass;
/* unused harmony export updateStylePropertyClass */
/* harmony export (immutable) */ __webpack_exports__["p"] = getSelectedProperty;
/* harmony export (immutable) */ __webpack_exports__["q"] = getSelectedStyleProperty;
/* harmony export (immutable) */ __webpack_exports__["m"] = getSelectedBackgroundImageStyleProperty;
/* harmony export (immutable) */ __webpack_exports__["r"] = getSelectedStylePropertyClass;
/* harmony export (immutable) */ __webpack_exports__["n"] = getSelectedClass;
/* harmony export (immutable) */ __webpack_exports__["y"] = updateSelectedStylePropertyClass;
/* harmony export (immutable) */ __webpack_exports__["v"] = setStylePropertyClass;
/* harmony export (immutable) */ __webpack_exports__["x"] = updateSelectedClasses;
/* harmony export (immutable) */ __webpack_exports__["a"] = copyTextAlignStyleToClass;
/* harmony export (immutable) */ __webpack_exports__["f"] = getAllSectionIds;
/* harmony export (immutable) */ __webpack_exports__["i"] = getHrefForComponent;
/* harmony export (immutable) */ __webpack_exports__["e"] = fromJSGreedy;
/* harmony export (immutable) */ __webpack_exports__["t"] = openLeftSidebar;
/* harmony export (immutable) */ __webpack_exports__["u"] = scrolling;
/* harmony export (immutable) */ __webpack_exports__["c"] = extractFonts;
/* harmony export (immutable) */ __webpack_exports__["w"] = uniqueWebFonts;
/* harmony export (immutable) */ __webpack_exports__["d"] = flattenTree;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__KeyPath__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_ElementTypes__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_LinkTypes__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_EditModes__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_Fonts__ = __webpack_require__(99);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }








function getElementAtPath(props, path) {
    if (!props || !path) {
        return null;
    }

    var model = getModel(path, props);
    if (!model) {
        return null;
    }

    return model.getIn(new __WEBPACK_IMPORTED_MODULE_0__KeyPath__["a" /* default */](path).toArray());
}

function getElementParent(props, path) {
    var model = getModel(path, props);
    var keyPath = new __WEBPACK_IMPORTED_MODULE_0__KeyPath__["a" /* default */](path).parent.parent;
    return model.getIn(keyPath.toArray());
}

function getSelectedElement(props) {
    var selectedPath = props.editorState.get('selected');
    if (selectedPath && selectedPath !== '0') {
        return getElementAtPath(props, selectedPath);
    }
    return null;
}

function getModel(path, _ref) {
    var pageModel = _ref.pageModel,
        siteModel = _ref.siteModel;

    var keyPath = new __WEBPACK_IMPORTED_MODULE_0__KeyPath__["a" /* default */](path);
    switch (keyPath.topElement) {
        case 'pageData':
            return pageModel;
        case 'siteData':
            return siteModel;
    }
}

function elementTypeFriendlyName(nodeType) {
    var templateName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var inputType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    var inputTypeMapping = {
        'file': 'file upload',
        'text': 'text field',
        'email': 'email field',
        'number': 'number field',
        'tel': 'phone field',
        'date': 'date field',
        'time': 'time field'
    };
    switch (nodeType) {
        case __WEBPACK_IMPORTED_MODULE_2__constants_ElementTypes__["c" /* COLUMN */]:
            return 'column';
        case __WEBPACK_IMPORTED_MODULE_2__constants_ElementTypes__["t" /* SECTION */]:
            return 'section';
        case __WEBPACK_IMPORTED_MODULE_2__constants_ElementTypes__["l" /* INLINE_APP */]:
            var json = templateName ? __webpack_require__(100) : null;
            return json ? json[templateName].title : 'app';
        case __WEBPACK_IMPORTED_MODULE_2__constants_ElementTypes__["r" /* REQUIRED_LABEL */]:
            return 'required label';
        case __WEBPACK_IMPORTED_MODULE_2__constants_ElementTypes__["p" /* RADIO_BUTTON_GROUP */]:
            return 'radio button group';
        case __WEBPACK_IMPORTED_MODULE_2__constants_ElementTypes__["b" /* CHECKBOX_GROUP */]:
            return 'checkbox group';
        case __WEBPACK_IMPORTED_MODULE_2__constants_ElementTypes__["h" /* FORM_BUTTON */]:
            return 'form button';
        case __WEBPACK_IMPORTED_MODULE_2__constants_ElementTypes__["y" /* TEXTAREA */]:
            return 'text area';
        case __WEBPACK_IMPORTED_MODULE_2__constants_ElementTypes__["v" /* SOCIAL_ICONS */]:
            return 'social icons';
        case __WEBPACK_IMPORTED_MODULE_2__constants_ElementTypes__["u" /* SELECT */]:
            return 'dropdown list';
        case __WEBPACK_IMPORTED_MODULE_2__constants_ElementTypes__["m" /* INPUT */]:
            return inputType ? inputTypeMapping[inputType] : nodeType;
        default:
            return nodeType;
    }
}

// Returns the sub directory name for the partner
function getPartnerPath(props) {
    var partnerCode = props.siteSettingsModel.getIn(['userSettings', 'partner_code']);
    if (!partnerCode || partnerCode === 'moonfruit') {
        return '';
    }
    return partnerCode + '/';
}

function getProperty(props, propName, path) {
    if (path && path !== '0') {
        var keyPathArr = new __WEBPACK_IMPORTED_MODULE_0__KeyPath__["a" /* default */](path).toArray();
        var element = getModel(path, props).getIn([].concat(_toConsumableArray(keyPathArr)));
        return element ? element.get(propName) : '';
    }
    return '';
}

function getModeStyleKey(editMode) {
    return editMode ? 'style-' + editMode : 'style';
}

function getStyleProperty(props, propName, path, editMode) {
    var styleMode = getModeStyleKey(editMode);

    if (path && path !== '0') {
        var styleProps = getModel(path, props).getIn([].concat(_toConsumableArray(new __WEBPACK_IMPORTED_MODULE_0__KeyPath__["a" /* default */](path).toArray()), [styleMode]));
        return styleProps ? styleProps.get(propName) : '';
    }
    return '';
}

function getStylePropertyClass(props, property, path, editMode) {
    return getClass(props, property, path, editMode);
}

function getClass(props, className, path, editMode) {
    var classes = getProperty(props, 'classes', path);
    if (classes) {
        var regex = editMode ? '^' + className + '-' + editMode : '^' + className + '-';
        var re = new RegExp(regex);

        classes = classes.toJSON();
        return classes.find(function (c) {
            return editMode ? c.match(re) : c.match(re) && !__WEBPACK_IMPORTED_MODULE_4__constants_EditModes__["a" /* EDIT_MODES */].find(function (edit) {
                return c.match(new RegExp(regex + (edit + '-')));
            });
        });
    }
    return '';
}

function updateStylePropertyClass(props, property, className, path) {

    var re = new RegExp("^" + property + "-");
    var elementClasses = getProperty(props, 'classes', path);
    var oldClasses = elementClasses ? elementClasses.toJSON() : [];

    var newClasses = oldClasses.filter(function (x) {
        return !x.match(re);
    });
    if (className) {
        // If not, it will be removed
        newClasses.push(className);
    }
    return newClasses;
}

function getSelectedProperty(props, propName) {
    var selectedPath = props.editorState.get('selected');
    return getProperty(props, propName, selectedPath);
}

function getSelectedStyleProperty(props, propName, editMode) {
    var selectedPath = props.editorState.get('selected');
    return getStyleProperty(props, propName, selectedPath, editMode);
}

function getSelectedBackgroundImageStyleProperty(props) {
    var selectedPath = props.editorState.get('selected');

    var backgroundImage = getStyleProperty(props, 'backgroundImage', selectedPath);
    if (backgroundImage) {
        return backgroundImage;
    }

    var background = getStyleProperty(props, 'background', selectedPath);
    if (background) {
        return background.match(/url\(([^)]+)\)/)[1];
    }
}

function getSelectedStylePropertyClass(props, property, editMode) {
    var selectedPath = props.editorState.get('selected');
    return getStylePropertyClass(props, property, selectedPath, editMode);
}

function getSelectedClass(props, className, editMode) {
    var selectedPath = props.editorState.get('selected');
    return getClass(props, className, selectedPath, editMode);
}

function updateSelectedStylePropertyClass(props, property, className, editMode) {
    var classes = getSelectedProperty(props, 'classes');
    var oldClasses = classes ? classes.toJSON() : [];
    return setStylePropertyClass(oldClasses, property, className, editMode);
}

function setStylePropertyClass(classList, property, newClass, editMode) {
    var regex = editMode ? '^' + property + '-' + editMode + '-' : '^' + property + '-';
    var re = new RegExp(regex);
    var newClasses = classList.filter(function (c) {
        return editMode ? !c.match(re) : !c.match(re) || __WEBPACK_IMPORTED_MODULE_4__constants_EditModes__["a" /* EDIT_MODES */].find(function (edit) {
            return c.match(new RegExp(regex + (edit + '-')));
        });
    });
    if (newClass) {
        // If not, it will be removed
        newClasses.push(newClass);
    }
    return newClasses;
}

function updateSelectedClasses(props, classNames) {
    var remove = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var elementClasses = getSelectedProperty(props, 'classes');
    var oldClasses = elementClasses ? elementClasses.toJSON() : [];

    // return all classes without the ones we are setting
    //  if !remove the classes will be added, else will be removed
    var newClasses = oldClasses.filter(function (x) {
        return !classNames.find(function (className) {
            return className === x;
        });
    });
    if (!remove) {
        classNames.forEach(function (className) {
            return newClasses.push(className);
        });
    }
    return newClasses;
}

function copyTextAlignStyleToClass(props) {
    var allStyles = props.style;
    var path = props.pathToMe;
    var alignClass = getStylePropertyClass(props, 'align', path);

    var classes = void 0;

    if (alignClass) {
        classes = getProperty(props, 'classes', path);
    } else {
        var updatedAlignClass = allStyles && allStyles.textAlign ? 'align-' + allStyles.textAlign : 'align-inherit';

        classes = updateStylePropertyClass(props, 'align', updatedAlignClass, path);
    }

    return classes;
}

function getAllSectionIds(props) {
    var headerSectionIds = props.siteModel.getIn(['siteData', 'header', 'containers']).map(function (c) {
        return c.get('id') || c.get('_key');
    });
    var footerSectionIds = props.siteModel.getIn(['siteData', 'footer', 'containers']).map(function (c) {
        return c.get('id') || c.get('_key');
    });
    var pageSectionIds = props.pageModel.getIn(['pageData', 'containers']).map(function (c) {
        return c.get('id') || c.get('_key');
    });
    var sectionIds = [].concat(_toConsumableArray(headerSectionIds), _toConsumableArray(pageSectionIds), _toConsumableArray(footerSectionIds));

    return sectionIds;
}

function getHrefForComponent(props) {
    var sectionIds = getAllSectionIds(props);
    var linkType = props.node.get('linkType');
    switch (linkType) {
        case __WEBPACK_IMPORTED_MODULE_3__constants_LinkTypes__["d" /* EMAIL */]:
            return props.node.get('href') ? 'mailto:' + props.node.get('href') : '';
        case __WEBPACK_IMPORTED_MODULE_3__constants_LinkTypes__["i" /* TOP_OF_THIS_PAGE */]:
            return '#' + sectionIds[0];
        case __WEBPACK_IMPORTED_MODULE_3__constants_LinkTypes__["b" /* BOTTOM_OF_THIS_PAGE */]:
            var last = sectionIds.length - 1;
            return '#' + sectionIds[last];
        case __WEBPACK_IMPORTED_MODULE_3__constants_LinkTypes__["c" /* CLICK_TO_CALL */]:
            return props.node.get('href') ? 'tel:' + props.node.get('href') : '';
        default:
            return props.node.get('href') || '';
    }
}

function fromJSGreedy(js) {
    return (typeof js === 'undefined' ? 'undefined' : _typeof(js)) !== 'object' || js === null || __WEBPACK_IMPORTED_MODULE_1_immutable___default.a.Iterable.isIterable(js) ? js : Array.isArray(js) ? __WEBPACK_IMPORTED_MODULE_1_immutable___default.a.Seq(js).map(fromJSGreedy).toList() : __WEBPACK_IMPORTED_MODULE_1_immutable___default.a.Seq(js).map(fromJSGreedy).toMap();
}

function openLeftSidebar(e, editorStateProperty, props) {
    e.stopPropagation();
    props.actions.setEditorStateProperty('isSideBarOpen', false);

    var toggleProperties = {
        'isLeftSidebarOpen': true,
        'isSiteSettingsOpen': false,
        'isMediaManagerOpen': false,
        'isAddBlockPanelOpen': editorStateProperty === 'isAddBlockPanelOpen',
        'isPageManagerOpen': editorStateProperty === 'isPageManagerOpen',
        'isAddElementPanelOpen': editorStateProperty === 'isAddElementPanelOpen'
    };

    Object.keys(toggleProperties).forEach(function (key) {
        if (props.editorState.get(key) !== toggleProperties[key]) {
            props.actions.setEditorStateProperty(key, toggleProperties[key]);
        }
    });
}

// inspired by joshcanhelp/scrollTo.js
// https://gist.github.com/joshcanhelp/a3a669df80898d4097a1e2c01dea52c1
// which itself was inspired by:
// Smooth scroll-to inspired by:
// http://stackoverflow.com/a/24559613/728480
//

function scrolling(scrollTo, elem) {
    var scrollDuration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000;

    var cosParameter = (elem.scrollTop - scrollTo) / 2,
        scrollCount = 0,
        oldTimestamp = window.performance.now();

    function step(newTimestamp) {
        var tsDiff = newTimestamp - oldTimestamp;

        scrollCount += Math.PI / (scrollDuration / tsDiff);
        if (scrollCount >= Math.PI) {
            return;
        }
        var moveStep = Math.round(scrollTo + cosParameter + cosParameter * Math.cos(scrollCount));
        elem.scrollTop = moveStep;
        oldTimestamp = newTimestamp;
        window.requestAnimationFrame(step);
    }
    window.requestAnimationFrame(step);
}

function extractFonts(parent) {
    var container = [];

    function extract(children) {
        if (children.style) {

            if (children.style.fontFamily) {
                container.push(children.style.fontFamily);
            }

            if (children.style.h1 && children.style.h1.fontFamily) {
                container.push(children.style.h1.fontFamily);
            }

            if (children.style.h2 && children.style.h2.fontFamily) {
                container.push(children.style.h2.fontFamily);
            }

            if (children.style[".logo"] && children.style[".logo"].fontFamily) {
                container.push(children.style[".logo"].fontFamily);
            }

            if (children.style[".dropdown-menu"] && children.style[".dropdown-menu"].fontFamily) {
                container.push(children.style[".dropdown-menu"].fontFamily);
            }
        }

        if (children.children && Array.isArray(children.children)) {
            children.children.map(extract);
        }
    }

    if (parent.containers && Array.isArray(parent.containers)) {
        parent.containers.map(extract);
    }

    return uniqueWebFonts(container);
}

function uniqueWebFonts(allFonts) {
    var cssFonts = new Set(__WEBPACK_IMPORTED_MODULE_5__constants_Fonts__["b" /* CSS_SAFE_FONTS */].map(function (font) {
        return font.value;
    }));

    return [].concat(_toConsumableArray(new Set(allFonts.filter(function (x) {
        return !cssFonts.has(x);
    }))));
}

function flattenTree(tree) {
    var flattenedTree = [];

    function flatten(item) {
        flattenedTree.push(item);
        if (item.children && item.children.length > 0) {
            item.children.forEach(flatten);
        }
    }
    tree.forEach(flatten);
    return flattenedTree;
}
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(getElementAtPath, 'getElementAtPath', '/usr/src/app/src/utils/Utils.js');

    __REACT_HOT_LOADER__.register(getElementParent, 'getElementParent', '/usr/src/app/src/utils/Utils.js');

    __REACT_HOT_LOADER__.register(getSelectedElement, 'getSelectedElement', '/usr/src/app/src/utils/Utils.js');

    __REACT_HOT_LOADER__.register(getModel, 'getModel', '/usr/src/app/src/utils/Utils.js');

    __REACT_HOT_LOADER__.register(elementTypeFriendlyName, 'elementTypeFriendlyName', '/usr/src/app/src/utils/Utils.js');

    __REACT_HOT_LOADER__.register(getPartnerPath, 'getPartnerPath', '/usr/src/app/src/utils/Utils.js');

    __REACT_HOT_LOADER__.register(getProperty, 'getProperty', '/usr/src/app/src/utils/Utils.js');

    __REACT_HOT_LOADER__.register(getModeStyleKey, 'getModeStyleKey', '/usr/src/app/src/utils/Utils.js');

    __REACT_HOT_LOADER__.register(getStyleProperty, 'getStyleProperty', '/usr/src/app/src/utils/Utils.js');

    __REACT_HOT_LOADER__.register(getStylePropertyClass, 'getStylePropertyClass', '/usr/src/app/src/utils/Utils.js');

    __REACT_HOT_LOADER__.register(getClass, 'getClass', '/usr/src/app/src/utils/Utils.js');

    __REACT_HOT_LOADER__.register(updateStylePropertyClass, 'updateStylePropertyClass', '/usr/src/app/src/utils/Utils.js');

    __REACT_HOT_LOADER__.register(getSelectedProperty, 'getSelectedProperty', '/usr/src/app/src/utils/Utils.js');

    __REACT_HOT_LOADER__.register(getSelectedStyleProperty, 'getSelectedStyleProperty', '/usr/src/app/src/utils/Utils.js');

    __REACT_HOT_LOADER__.register(getSelectedBackgroundImageStyleProperty, 'getSelectedBackgroundImageStyleProperty', '/usr/src/app/src/utils/Utils.js');

    __REACT_HOT_LOADER__.register(getSelectedStylePropertyClass, 'getSelectedStylePropertyClass', '/usr/src/app/src/utils/Utils.js');

    __REACT_HOT_LOADER__.register(getSelectedClass, 'getSelectedClass', '/usr/src/app/src/utils/Utils.js');

    __REACT_HOT_LOADER__.register(updateSelectedStylePropertyClass, 'updateSelectedStylePropertyClass', '/usr/src/app/src/utils/Utils.js');

    __REACT_HOT_LOADER__.register(setStylePropertyClass, 'setStylePropertyClass', '/usr/src/app/src/utils/Utils.js');

    __REACT_HOT_LOADER__.register(updateSelectedClasses, 'updateSelectedClasses', '/usr/src/app/src/utils/Utils.js');

    __REACT_HOT_LOADER__.register(copyTextAlignStyleToClass, 'copyTextAlignStyleToClass', '/usr/src/app/src/utils/Utils.js');

    __REACT_HOT_LOADER__.register(getAllSectionIds, 'getAllSectionIds', '/usr/src/app/src/utils/Utils.js');

    __REACT_HOT_LOADER__.register(getHrefForComponent, 'getHrefForComponent', '/usr/src/app/src/utils/Utils.js');

    __REACT_HOT_LOADER__.register(fromJSGreedy, 'fromJSGreedy', '/usr/src/app/src/utils/Utils.js');

    __REACT_HOT_LOADER__.register(openLeftSidebar, 'openLeftSidebar', '/usr/src/app/src/utils/Utils.js');

    __REACT_HOT_LOADER__.register(scrolling, 'scrolling', '/usr/src/app/src/utils/Utils.js');

    __REACT_HOT_LOADER__.register(extractFonts, 'extractFonts', '/usr/src/app/src/utils/Utils.js');

    __REACT_HOT_LOADER__.register(uniqueWebFonts, 'uniqueWebFonts', '/usr/src/app/src/utils/Utils.js');

    __REACT_HOT_LOADER__.register(flattenTree, 'flattenTree', '/usr/src/app/src/utils/Utils.js');
}();

;

/***/ }),

/***/ 176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return NONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLICK_TO_CALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TOP_OF_THIS_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BOTTOM_OF_THIS_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALL_OPTIONS; });
var NONE = "none";
var URL = "url";
var CLICK_TO_CALL = "click-to-call";
var EMAIL = "email";
var FILE = "file";
var PAGE = "page";
var TOP_OF_THIS_PAGE = "top";
var BOTTOM_OF_THIS_PAGE = "bottom";
var SECTION = "any-section";

var ALL_OPTIONS = [{ label: 'None', value: NONE }, { label: 'URL', value: URL }, { label: 'Phone number', value: CLICK_TO_CALL }, { label: 'Email', value: EMAIL }, { label: 'File', value: FILE }, { label: 'Page', value: PAGE }, { label: 'Top of this page', value: TOP_OF_THIS_PAGE }, { label: 'Bottom of this page', value: BOTTOM_OF_THIS_PAGE }, { label: 'Section', value: SECTION }];
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(NONE, "NONE", "/usr/src/app/src/constants/LinkTypes.js");

    __REACT_HOT_LOADER__.register(URL, "URL", "/usr/src/app/src/constants/LinkTypes.js");

    __REACT_HOT_LOADER__.register(CLICK_TO_CALL, "CLICK_TO_CALL", "/usr/src/app/src/constants/LinkTypes.js");

    __REACT_HOT_LOADER__.register(EMAIL, "EMAIL", "/usr/src/app/src/constants/LinkTypes.js");

    __REACT_HOT_LOADER__.register(FILE, "FILE", "/usr/src/app/src/constants/LinkTypes.js");

    __REACT_HOT_LOADER__.register(PAGE, "PAGE", "/usr/src/app/src/constants/LinkTypes.js");

    __REACT_HOT_LOADER__.register(TOP_OF_THIS_PAGE, "TOP_OF_THIS_PAGE", "/usr/src/app/src/constants/LinkTypes.js");

    __REACT_HOT_LOADER__.register(BOTTOM_OF_THIS_PAGE, "BOTTOM_OF_THIS_PAGE", "/usr/src/app/src/constants/LinkTypes.js");

    __REACT_HOT_LOADER__.register(SECTION, "SECTION", "/usr/src/app/src/constants/LinkTypes.js");

    __REACT_HOT_LOADER__.register(ALL_OPTIONS, "ALL_OPTIONS", "/usr/src/app/src/constants/LinkTypes.js");
}();

;

/***/ }),

/***/ 366:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 367:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;

/***/ }),

/***/ 46:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./src/config/base.js


// Settings configured here will be merged into the final config object.

var _default = {
    baseUrlPath: '/_html5/',
    checkDomainServiceUrl: 'https://41jnr1e5h0.execute-api.eu-west-1.amazonaws.com',
    okIPList: [],
    goodIPList: ["93.184.220.23", "72.21.91.23", "68.232.44.23", "85.233.160.101"],
    cnameList: ["cdn.sitemakerlive.com"],
    hostnameBaseURL: '', // Change your dev.js to point at your dev.vm, ex http://qwerty.lazevedo.dev if your dev.vm supports CORS
    uploadBaseURL: '', // Change your dev.js to point at your dev.vm, ex http://lazevedo.dev if your dev.vm supports CORS

    //Google font api
    googleFontApiKey: "AIzaSyBtpFxSlxixYvucPjAkiOeWWYyhi2oROlo",
    googleFontApiUrl: "https://www.googleapis.com/webfonts/v1/webfonts",

    // Feature flips
    enableToSwitchRevisions: false, // Enable page revision switcher in the UI
    enableLogging: false, // Enable logging (mainly for redux middleware)
    enableDevSidebarPanel: false, // Enable Dev Features in the Sidebar
    enableToolbarSaveButton: false, // Toolbar save button, disable for production
    enableSidebarEditorTab: false // Extra tab on the side bar to configure editor features
};
/* harmony default export */ var base = (_default);
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_default, 'default', '/usr/src/app/src/config/base.js');
}();

;
// CONCATENATED MODULE: ./src/config/dist.js




var config = {
  appEnv: 'dist', // feel free to remove the appEnv property here
  enableDevSidebarPanel: false,
  stripePublicKey: 'pk_live_0YPDAIjF3qzJ0LjQcx26msw5'
};

var dist__default = Object.freeze(Object.assign({}, base, config));

/* harmony default export */ var dist = __webpack_exports__["a"] = (dist__default);
;

var dist__temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(config, 'config', '/usr/src/app/src/config/dist.js');

  __REACT_HOT_LOADER__.register(dist__default, 'default', '/usr/src/app/src/config/dist.js');
}();

;

/***/ }),

/***/ 470:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = sanitizeHtml;
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchThumbnailUrl;
/* harmony export (immutable) */ __webpack_exports__["a"] = cropHtml;
function sanitizeHtml(input) {
    var tagBlackList = {
        'SCRIPT': true
    };

    var attributeWhitelist = {
        'href': true,
        'src': true,
        'target': true
    };

    var iframe = document.createElement('iframe');
    if (iframe['sandbox'] === undefined) {
        console.warn("Unable to sanitize html.");
        return;
    }

    iframe['sandbox'] = 'allow-same-origin';
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    iframe.contentDocument.body.innerHTML = input;

    function makeSanitizedCopy(node) {
        var newNode = void 0;
        if (node.nodeType == Node.TEXT_NODE) {
            newNode = node.cloneNode(true);
        } else if (node.nodeType == Node.ELEMENT_NODE && !tagBlackList[node.tagName]) {
            newNode = iframe.contentDocument.createElement(node.tagName);
            for (var i = 0; i < node.attributes.length; i++) {
                var attr = node.attributes[i];
                if (attributeWhitelist[attr.name]) {
                    newNode.setAttribute(attr.name, attr.value);
                }
            }
            for (i = 0; i < node.childNodes.length; i++) {
                var subCopy = makeSanitizedCopy(node.childNodes[i]);
                newNode.appendChild(subCopy, false);
            }
        } else {
            newNode = document.createDocumentFragment();
        }
        return newNode;
    }

    var resultElement = makeSanitizedCopy(iframe.contentDocument.body);
    document.body.removeChild(iframe);
    return resultElement.innerHTML;
}

function fetchThumbnailUrl(input) {
    var iframe = document.createElement('iframe');
    if (iframe['sandbox'] === undefined) {
        console.warn("Unable to fetch thumbnail URL.");
        return;
    }
    iframe['sandbox'] = 'allow-same-origin';
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    iframe.contentDocument.body.innerHTML = input;

    function findImageUrl(node) {
        var imageUrl = '';
        if (node.nodeType == Node.ELEMENT_NODE && node.tagName == 'IMG' && node.getAttribute('src')) {
            imageUrl = node.getAttribute('src');
        } else {
            for (var i = 0; i < node.childNodes.length && !imageUrl; i++) {
                imageUrl = findImageUrl(node.childNodes[i]);
            }
        }
        return imageUrl;
    }

    var url = findImageUrl(iframe.contentDocument.body);
    document.body.removeChild(iframe);
    return url;
}

function cropHtml(input, characterLimit) {
    var tagBlackList = {
        'IMG': true,
        'BR': true,
        'IFRAME': true,
        'VIDEO': true,
        'BLOCKQUOTE': true
    };

    var iframe = document.createElement('iframe');
    if (iframe['sandbox'] === undefined) {
        console.warn("Unable to crop html.");
        return input;
    }

    iframe['sandbox'] = 'allow-same-origin';
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    iframe.contentDocument.body.innerHTML = input;

    function makeCroppedCopy(node, limit) {
        var newNode = void 0,
            newCharacterLimit = void 0;
        newCharacterLimit = limit;

        if (node.nodeType == Node.TEXT_NODE) {
            if (node.textContent.length <= newCharacterLimit) {
                newNode = node.cloneNode(true);
                newCharacterLimit = newCharacterLimit - node.textContent.length;
            } else {
                var slicedText = node.textContent.slice(0, newCharacterLimit);
                var lastIndex = slicedText.lastIndexOf(" ");
                var croppedText = slicedText.substring(0, lastIndex);

                newNode = iframe.contentDocument.createTextNode(croppedText + '...');
                newCharacterLimit = 0;
            }
        } else if (node.nodeType == Node.ELEMENT_NODE && !tagBlackList[node.tagName]) {
            newNode = iframe.contentDocument.createElement(node.tagName);
            for (var i = 0; i < node.attributes.length; i++) {
                var attr = node.attributes[i];
                newNode.setAttribute(attr.name, attr.value);
            }
            if (node.tagName == 'A' && node.getAttribute('href')) {
                newNode.setAttribute('target', '_blank');
            }
            for (var i = 0; i < node.childNodes.length && newCharacterLimit > 0; i++) {
                var subCopy = makeCroppedCopy(node.childNodes[i], newCharacterLimit);
                newNode.appendChild(subCopy[0], false);
                newCharacterLimit = subCopy[1];
            }
        } else {
            newNode = document.createDocumentFragment();
        }
        return [newNode, newCharacterLimit];
    }

    var resultElement = makeCroppedCopy(iframe.contentDocument.body, characterLimit);
    document.body.removeChild(iframe);
    return resultElement[0].innerHTML;
}
;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(sanitizeHtml, 'sanitizeHtml', '/usr/src/app/src/utils/Feed.js');

    __REACT_HOT_LOADER__.register(fetchThumbnailUrl, 'fetchThumbnailUrl', '/usr/src/app/src/utils/Feed.js');

    __REACT_HOT_LOADER__.register(cropHtml, 'cropHtml', '/usr/src/app/src/utils/Feed.js');
}();

;

/***/ }),

/***/ 57:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EDIT_MODES; });
/* unused harmony export EDIT_MODES_MAPPING */
/* harmony export (immutable) */ __webpack_exports__["b"] = getEditMode;
var EDIT_MODES = ['md', 'sm', 'xs'];

var EDIT_MODES_MAPPING = {
  'mode-md-active': 'md',
  'mode-sm-active': 'sm',
  'mode-xs-active': 'xs',
  default: 'md'
};

function getEditMode(canvasSizeClass) {
  return EDIT_MODES_MAPPING[canvasSizeClass] || EDIT_MODES_MAPPING.default;
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(EDIT_MODES, 'EDIT_MODES', '/usr/src/app/src/constants/EditModes.js');

  __REACT_HOT_LOADER__.register(EDIT_MODES_MAPPING, 'EDIT_MODES_MAPPING', '/usr/src/app/src/constants/EditModes.js');

  __REACT_HOT_LOADER__.register(getEditMode, 'getEditMode', '/usr/src/app/src/constants/EditModes.js');
}();

;

/***/ }),

/***/ 70:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_head__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_head___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_head__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_last__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_last__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_nth__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_nth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_nth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_take__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_take___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_take__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_reduce__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_toNumber__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_toNumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_toNumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_toPath__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_toPath___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_toPath__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isNaN__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isNaN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_isNaN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isString__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isArray__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_isArray__);













var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
*  [root]  [sections]    [rows]      [columns]
* pageData.containers[0].children[0].children[0]
*
*/
var KeyPath = function () {
    function KeyPath(path) {
        _classCallCheck(this, KeyPath);

        this._pathArray = __WEBPACK_IMPORTED_MODULE_9_lodash_isArray___default()(path) ? path : __WEBPACK_IMPORTED_MODULE_6_lodash_toPath___default()(path);
        this._pathString = __WEBPACK_IMPORTED_MODULE_8_lodash_isString___default()(path) ? path : __WEBPACK_IMPORTED_MODULE_4_lodash_reduce___default()(this._pathArray, this._reduceToSting, "");
    }

    _createClass(KeyPath, [{
        key: 'toArray',
        value: function toArray() {
            return [].concat(_toConsumableArray(this._pathArray));
        }
    }, {
        key: 'toString',
        value: function toString() {
            return this._pathString;
        }
    }, {
        key: 'getItemAt',
        value: function getItemAt(index) {
            return __WEBPACK_IMPORTED_MODULE_2_lodash_nth___default()(this.toArray(), index);
        }
    }, {
        key: '_reduceToSting',
        value: function _reduceToSting(result, value, idx) {
            //if current value is a property and nor an index i.e. cant be converted to a number
            if (__WEBPACK_IMPORTED_MODULE_7_lodash_isNaN___default()(__WEBPACK_IMPORTED_MODULE_5_lodash_toNumber___default()(value))) {
                //if it is not the first one add a point in front of it
                if (idx !== 0) {
                    result += '.';
                }
                //add the property
                result += value;
                //else if it is an array index
            } else {
                //add the index in array access operator
                result += '[' + value + ']';
            }
            return result;
        }
    }, {
        key: 'parent',
        get: function get() {
            var parentPath = __WEBPACK_IMPORTED_MODULE_3_lodash_take___default()(this.toArray(), this.length - 1);
            return new KeyPath(parentPath);
        }
    }, {
        key: 'length',
        get: function get() {
            return this.toArray().length;
        }
    }, {
        key: 'lastIndex',
        get: function get() {
            return __WEBPACK_IMPORTED_MODULE_1_lodash_last___default()(this.toArray());
        }
    }, {
        key: 'topElement',
        get: function get() {
            return __WEBPACK_IMPORTED_MODULE_0_lodash_head___default()(this.toArray());
        }
    }]);

    return KeyPath;
}();

var _default = KeyPath;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(KeyPath, 'KeyPath', '/usr/src/app/src/utils/KeyPath.js');

    __REACT_HOT_LOADER__.register(_default, 'default', '/usr/src/app/src/utils/KeyPath.js');
}();

;

/***/ }),

/***/ 99:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/isomorphic-fetch/fetch-npm-browserify.js
var fetch_npm_browserify = __webpack_require__(238);
var fetch_npm_browserify_default = /*#__PURE__*/__webpack_require__.n(fetch_npm_browserify);

// EXTERNAL MODULE: ./src/config/dist.js + 1 modules
var dist = __webpack_require__(46);

// CONCATENATED MODULE: ./src/services/GoogleFontClient.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var API_KEY = dist["a" /* default */].googleFontApiKey;
var GOOGLE_FONT_URL = dist["a" /* default */].googleFontApiUrl;

var GoogleFontClient_GoogleFontClient = function () {
  function GoogleFontClient() {
    _classCallCheck(this, GoogleFontClient);
  }

  _createClass(GoogleFontClient, [{
    key: 'getFontList',
    value: function getFontList() {
      var url = GOOGLE_FONT_URL + '?key=' + API_KEY;
      return fetch_npm_browserify_default()(url, { method: "GET" }).then(function (res) {
        return res.json();
      });
    }
  }]);

  return GoogleFontClient;
}();


;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(API_KEY, 'API_KEY', '/usr/src/app/src/services/GoogleFontClient.js');

  __REACT_HOT_LOADER__.register(GOOGLE_FONT_URL, 'GOOGLE_FONT_URL', '/usr/src/app/src/services/GoogleFontClient.js');

  __REACT_HOT_LOADER__.register(GoogleFontClient_GoogleFontClient, 'GoogleFontClient', '/usr/src/app/src/services/GoogleFontClient.js');
}();

;
// CONCATENATED MODULE: ./src/constants/Fonts.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return WEB_LOAD_FONT_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CSS_SAFE_FONTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALL_GOOGLE_FONTS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PREFERRED_FONTS_LIST; });


var fontList = ["Alegreya Sans", "Amatica SC", "Amiko", "Arima Madurai", "Arvo", "Baloo", "Bree Serif", "Bungee", "Bungee Shade", "Coming Soon", "Cookie", "Cormorant", "Cormorant SC", "Cormorant Upright", "Crimson Text", "Cuprum", "Dancing Script", "Domine", "Dosis", "Droid Sans", "Droid Serif", "Gloria Hallelujah", "Gravitas One", "Great Vibes", "Gudea", "Hind", "Indie Flower", "Josefin Sans", "Julius Sans One", "Lalezar", "Libre Baskerville", "Lora", "Luckiest Guy", "Monoton", "Noticia Text", "Nunito", "Open Sans", { label: "Open Sans Condensed", value: "Open Sans Condensed", weights: [300] }, "Pacifico", "Play", "Playball", "Poiret One", "Pontano Sans", "Quicksand", "Raleway", "Rokkitt", "Sacramento", "Sanchez", "Scope One", "Shadows Into Light", "Six Caps", "Space Mono", "Special Elite", "Work Sans", "Aldrich", "Alegreya", "Alex Brush", "Alice", "Alike", "Alegreya Sans SC", "Allerta Stencil", "Amaranth", "Amatic SC", "Amethysta", "Amiri", "Andada", "Anton", "Arbutus Slab", "Archivo Black", "Belgrano", "Berkshire Swash", "BioRhyme", "Black Ops One", "Boogaloo", "Bubblegum Sans", "Butterfly Kids", "Cabin", "Cardo", "Clicker Script", "Comfortaa", "Contrail One", "Copse", "Coustard", "Didact Gothic", "EB Garamond", "Exo", "Fanwood Text", "Fauna One", "Fjalla One", "Francois One", "Gabriela", "Gochi Hand", "Halant", "Hammersmith One", "Handlee", "Headland One", "Holtwood One SC", "IM Fell English SC", "Jaldi", "Josefin Slab", "Jura", "Just Another Hand", "Kameron", "Karma", "Kreon", "Lato", "Lobster", "Lusitana", "Lustria", "Marmelad", "Martel", "Mate", "Merriweather", "Montserrat", "Oranienbaum", "Oswald", "Overlock", "Pangolin", "Pathway Gothic One", "Peddana", "Permanent Marker", "Pinyon Script", "Playfair Display", "Poppins", "Pragati Narrow", "PT Sans", "Radley", "Rajdhani", "Rasa", "Roboto", "Roboto Condensed", "Roboto Slab", "Rochester", "Rocksalt", "Rubik", "Russo One", "Sansita", "Shrikhand", "Sigmar One", "Signika", "Slabo 13px", "Sofia", "Source Code Pro", "Source Sans Pro", "Source Serif Pro", "Sue Ellen Francisco", "Suez One", "Teko", "Trocchi", "Ultra", "Varela Round", "Viga", "Vollkorn", "Muli", "Neuton", "Cormorant Garamond", "Abril Fatface", "Ubuntu", "PT Serif", "Old Standard TT"];

var WEB_LOAD_FONT_LIST = fontList.map(function (f) {
    return typeof f === 'string' ? { label: f, value: f } : f;
}).sort(sortByLabel);

var CSS_SAFE_FONTS = [{
    label: 'Georgia',
    value: 'Georgia, serif'
}, {
    label: 'Platino',
    value: '"Palatino Linotype", "Book Antiqua", Palatino, serif'
}, {
    label: 'Times New Roman',
    value: '"Times New Roman", Times, serif'
}, {
    label: 'Arial',
    value: 'Arial, Helvetica, sans-serif'
}, {
    label: 'Comic Sans',
    value: '"Comic Sans MS", cursive, sans-serif'
}, {
    label: 'Impact',
    value: 'Impact, Charcoal, sans-serif'
}, {
    label: 'Lucida Sans',
    value: '"Lucida Sans Unicode", "Lucida Grande", sans-serif'
}, {
    label: 'Tahoma',
    value: 'Tahoma, Geneva, sans-serif'
}, {
    label: 'Trebuchet',
    value: '"Trebuchet MS", Helvetica, sans-serif'
}, {
    label: 'Verdana',
    value: 'Verdana, Geneva, sans-serif'
}, {
    label: 'Monospace',
    value: 'Monospace Fonts'
}, {
    label: 'Courier',
    value: '"Courier New", Courier, monospace'
}, {
    label: 'Lucida Console',
    value: '"Lucida Console", Monaco, monospace'
}];

function sortByLabel(a, b) {
    if (a.label === b.label) return 0;
    return a.label > b.label ? 1 : -1;
}

var ALL_GOOGLE_FONTS_LIST = new GoogleFontClient_GoogleFontClient().getFontList().then(function (fonts) {
    return fonts.items.filter(function (item) {
        return !WEB_LOAD_FONT_LIST.find(function (font) {
            return font.label === item.family;
        });
    });
});

var PREFERRED_FONTS_LIST = [{
    label: 'Web Safe fonts',
    value: '_separator'
}].concat(CSS_SAFE_FONTS.sort(sortByLabel)).concat([{
    label: 'Featured Web Fonts',
    value: '_separator'
}]).concat(WEB_LOAD_FONT_LIST).concat([{
    label: 'More Web Fonts',
    value: '_separator'
}]);
;

var Fonts__temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(fontList, "fontList", "/usr/src/app/src/constants/Fonts.js");

    __REACT_HOT_LOADER__.register(WEB_LOAD_FONT_LIST, "WEB_LOAD_FONT_LIST", "/usr/src/app/src/constants/Fonts.js");

    __REACT_HOT_LOADER__.register(CSS_SAFE_FONTS, "CSS_SAFE_FONTS", "/usr/src/app/src/constants/Fonts.js");

    __REACT_HOT_LOADER__.register(sortByLabel, "sortByLabel", "/usr/src/app/src/constants/Fonts.js");

    __REACT_HOT_LOADER__.register(ALL_GOOGLE_FONTS_LIST, "ALL_GOOGLE_FONTS_LIST", "/usr/src/app/src/constants/Fonts.js");

    __REACT_HOT_LOADER__.register(PREFERRED_FONTS_LIST, "PREFERRED_FONTS_LIST", "/usr/src/app/src/constants/Fonts.js");
}();

;

/***/ })

});


// WEBPACK FOOTER //
// app-common.js